import BaseObject, { newId } from "./models/BaseObject";
import TaskDialog from "./TaskDialog";
import { showToast } from "./components/Toasts";
import { isDevelopmentEnvironment } from "./estada-config";

export enum TaskGroup {
  Unknown = "Unknown",
  DataInconsistency = "DataInconsistency", // no itx
}

export class Task {
  group: TaskGroup = TaskGroup.Unknown;

  title: string = ""; //"Verbraucher mit mehreren Verbindungen",
  object: BaseObject | undefined; // this,
  interactions: Array<{ id: string; caption: string; action: () => void }> = new Array<{
    id: string;
    caption: string;
    action: () => void;
  }>();

  // [{
  // caption: "Lösche Verbindung zu: " + "K1.H",
  // action: ()=>{
  // connection1.delete();
  // task (this?) .close();
  // },
  // {
  // caption: "Lösche Verbindung zu: " + "K2.A",
  // connection12.delete();
  // task (this?) .close();
  // }
  // }]
}

enum MessageType {
  Info,
  Consistency,
}

export default class TaskAndMessageManager extends BaseObject {
  public get className(): string {
    return "TaskAndMessageManager"; // no itx
  }
  tasks: Array<Task> = new Array<Task>();

  messages: Map<MessageType, Array<string>> = new Map();

  addUserTask(task: Task) {
    // here what to do with the task?
    this.tasks.push(task);
  }

  showTasks(task: Task) {
    if (task.group == TaskGroup.DataInconsistency) {
      state.dialogManager.openDialog(<TaskDialog task={task} />);
    }
  }
  removeTask(toRemoveTask: Task) {
    for (let i = 0; i < this.tasks.length; i++) {
      const task = this.tasks[i];
      if (task == toRemoveTask) {
        // remove here and break
        this.tasks.splice(i, 1);
        break;
      }
    }
  }

  addUserMessage(message: string) {
    // here what to do with message?
    const messageArray = this.messages.get(MessageType.Info) || [];
    messageArray.push(message);
    this.messages.set(MessageType.Info, messageArray);
  }

  addConsistencyMessage(message: string) {
    // here what to do with message?
    // verwirrend für user
    if (!isDevelopmentEnvironment()) {
      return;
    }
    const messageArray = this.messages.get(MessageType.Consistency) || [];
    messageArray.push(message);
    this.messages.set(MessageType.Consistency, messageArray);
  }

  showMessage(message: string) {
    showToast({ text: message });
  }

  get hasConsistencyMessages(): boolean {
    const messageArray = this.messages.get(MessageType.Consistency) || [];
    return messageArray.length > 0;
  }

  get consitencyMessages(): Array<string> {
    const messageArray = this.messages.get(MessageType.Consistency) || [];
    return messageArray;
  }

  clear() {
    this.tasks = [];
    this.messages = new Map();
  }
}
